var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"help-link",on:{"click":function($event){return _vm.$store.commit('config/setActiveHelpTopicPath', _vm.path)}}},[_c('i',{staticClass:"mdi mdi-help-box"}),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }